export function makeInclosureImage(svg, w1, h1, labelHeader, labelWidth, labelHeight, bottomBracketSize, rightBracketSize) {
    const innerWidth = w1 + 50;
    const innerHeight = h1 - 70 ;
    const d = 7;
    const dw = 40;
    const dw_tooth = 10;
    
    return `
      <svg width="${w1+120}" height="${h1 + 0}" xmlns="http://www.w3.org/2000/svg">
        <!-- Header Label -->
        <text x="40%" y="20" font-size="16" text-anchor="middle" font-weight="bold">${labelHeader}</text>
        
        <!-- Image Content -->
        <svg x="0" y="30" width="${innerWidth}" height="${innerHeight}">
          ${svg}
        </svg>
        
        <!-- Width Label with Adjustable Horizontal Bracket Stuck to Bottom Left Corner -->
        <line x1="0" y1="${h1 - dw}" x2="${bottomBracketSize}" y2="${h1 - dw}" stroke="blue" stroke-width="0.5"/>
        <line x1="0" y1="${h1 - dw - dw_tooth}" x2="0" y2="${h1 - dw}" stroke="black" stroke-width="0.5"/>
        <line x1="${bottomBracketSize}" y1="${h1 - dw - dw_tooth}" x2="${bottomBracketSize}" y2="${h1 - dw}" stroke="black" stroke-width="0.5"/>
        <text x="${bottomBracketSize / 2}" y="${h1 - dw_tooth - 5}" font-size="16" text-anchor="middle" font-weight="bold">${labelWidth}</text>
        
        <!-- Height Label with Vertical Bracket (Moved Up by 2 Units) -->
        <!-- vertical line: -->
        <line x1="${w1 + 32}" y1="${(innerHeight - rightBracketSize) / 2 + 65}"    x2="${w1 + 32}" y2="${(innerHeight + rightBracketSize) / 2 - 27}"     stroke="blue" stroke-width="0.5"/>
        <!-- small horizontal up -->
        <line x1="${w1 + 32}" y1="${(innerHeight - rightBracketSize) / 2 + 65}"    x2="${w1 + 17}" y2="${(innerHeight - rightBracketSize) / 2 + 65}" stroke="blue" stroke-width="0.5"/>    
        <!-- small horizontal bottom -->
        <line x1="${w1 + 32}" y1="${(innerHeight + rightBracketSize) / 2  - 27}"    x2="${w1 + 17}" y2="${(innerHeight + rightBracketSize) / 2 - 27}" stroke="blue" stroke-width="0.5"/>

        <text x="${w1 + 50}" y="${rightBracketSize/2}" font-size="16" text-anchor="start" transform="rotate(90 ${w1 + 50},50%)" font-weight="bold">${labelHeight}</text>
      </svg>
    `;
  }